import { Drawer as FluentDrawer } from "@fluentui/web-components";
/**
 * Drawer
 * @summary A Drawer component that allows content to be displayed in a side panel. It can be rendered as modal or non-modal.
 *
 * @example
 * ```html
 * <fabric-drawer type="modal" position="start" size="large" aria-labelledby="drawer-title" aria-describedby="drawer-description">
 *   <span slot="title">Title Content</span>
 *   <span slot="close">Close Button</span>
 *   Main Content
 *   <div slot="footer">Footer Content</div>
 * </fabric-drawer>
 * ```
 *
 * @attr {DrawerType} type - Determines whether the drawer should be displayed as modal, non-modal, or alert.
 * @attr {DrawerPosition} position - Sets the position of the drawer (start/end).
 * @attr {DrawerSize} size - Sets the size of the drawer (small/medium/large/full).
 * @attr {string} ariaDescribedby - The ID of the element that describes the drawer.
 * @attr {string} ariaLabelledby - The ID of the element that labels the drawer.
 *
 * @prop {DrawerType} type - Determines whether the drawer should be displayed as modal, non-modal, or alert.
 * @prop {DrawerPosition} position - Sets the position of the drawer (start/end).
 * @prop {DrawerSize} size - Sets the size of the drawer (small/medium/large/full).
 * @prop {string} ariaDescribedby - The ID of the element that describes the drawer.
 * @prop {string} ariaLabelledby - The ID of the element that labels the drawer.
 *
 * @slot - Default slot for the content of the drawer.
 * @slot title - Slot for the title content of the drawer.
 * @slot close - Slot for the close button of the drawer.
 * @slot footer - Slot for the footer content of the drawer.
 *
 * @csspart dialog - The dialog element of the drawer.
 *
 * @method show() - Shows the drawer.
 * @method hide() - Hides the drawer.
 * @method clickHandler() - Handles click events on the drawer.
 *
 * @fires {CustomEvent} toggle - Event emitted after the dialog's open state changes.
 * @fires {CustomEvent} beforetoggle - Event emitted before the dialog's open state changes.
 *
 * @extends FluentDrawer
 * @tagname fabric-drawer
 * @public
 */
export class Drawer extends FluentDrawer {
}
//# sourceMappingURL=drawer.js.map